import { getDisplayDateKey } from "@/lib/displayDateTime";
/**
 * PortalFooter — a slim global footer pinned to the bottom of the main content
 * column in both the admin and client shells.
 *
 * Purpose: give every page a defined bottom boundary so tall, auto-scrolling
 * pages (e.g. the client My Events calendar, the admin kanban boards) don't
 * feel cramped where the content runs out. Intentionally minimal — a single
 * copyright line in muted text, matching the portal's quiet chrome.
 */

export function PortalFooter() {
  const year = getDisplayDateKey().slice(0, 4);

  return (
    <footer className="border-t border-border/60 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 py-3 sm:px-6">
      <p className="text-center text-xs text-muted-foreground">
        © {year} Habits365Greek
      </p>
    </footer>
  );
}

export default PortalFooter;
